export const reserveStatus = {
    AVAILABLE: "AVAILABLE",
    FULL: "FULL",
    CLOSED: "CLOSED"
}

export const repeatStatus = {
    EVERY_DAY: "EVERY_DAY",
    EVERY_WEEKDAY: "EVERY_WEEKDAY",
    EVERY_WEEKEND: "EVERY_WEEKEND",
}

export const bookingStatus = {
    ACTIVE: "ACTIVE",
    USED: "USED",
    EXPIRED: "EXPIRED",
    CANCELLED: "CANCELLED"
}